import { render, staticRenderFns } from "./Institutional.vue?vue&type=template&id=d9c1c848&scoped=true"
import script from "./Institutional.vue?vue&type=script&lang=js"
export * from "./Institutional.vue?vue&type=script&lang=js"
import style0 from "./Institutional.vue?vue&type=style&index=0&id=d9c1c848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c1c848",
  null
  
)

export default component.exports